<template>
  <mds-input
    :placeholder="placeholder"
    v-bind:hidden-label="hideLabel"
    v-bind:right-aligned="istextRightAligned"
    :label="label"
    :disabled="isDisabled"
    :value="`${FormatedValue}`"
    v-bind="$attrs"
    :microcopy-below="microcopyBelow"
    @keypress="numbersOnly"
    @focus="changeFormatToNumber($event.target.value)"
    @blur="triggerChange($event.target.value)"
    @keyup="onKeyUp"
    :maxlength="maxlength"
    :maxvalue="maxvalue"
    @input="subscribeInputChange"
    :error="isError"
    :error-text="errorText"
  ></mds-input>
</template>
<script>
import MdsInput from "@mds/input";
import { format } from "d3-format";
export default {
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    istextRightAligned: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
      default: 10,
    },
    maxvalue: {
      type: Number,
      default: 0,
    },
    minvalue: {
      type: Number,
      default: 0,
    },
    errorText: {
      type: Array,
    },
    isError: {
      type: Boolean,
    },
    label: {
      type: String,
    },
    isDisabled: {
      type: Boolean,
    },
    microcopyBelow: {
      type: String,
    },
    isAllowOnlyNumber: {
      type: Boolean,
    },
    isAllowOnlyInteger: {
      type: Boolean,
    },
    AllowOnlyDecimalTill: {
      type: Number,
      default: 0,
    },
    currencyFormat: {
      type: String,
    },
    appendText: {
      type: String,
    },
    callBackMethod: {
      type: String,
    },
    value: {
      type: [Number, String],
      default: 0,
    },
  },
  components: {
    MdsInput,
  },

  data() {
    return {
      isFocus: false,
      refreshKey: 0,
    };
  },
  computed: {
    isAllowNegative() {
      if (!isNaN(this.minvalue) && this.minvalue < 0) {
        return true;
      } else {
        return false;
      }
    },
    FormatedValue() {
      const { value } = this;
      if (this.isAllowOnlyNumber == false) return value;

      this.refreshKey;
      if (!this.isFocus && value !== "") {
        if (this.appendText && this.appendText != "") {
          return value + this.appendText;
        } else if (this.currencyFormat && this.currencyFormat != "") {
          return format(this.currencyFormat)(value);
        } else {
          return value;
        }
      } else {
        return value;
      }
    },
    getlengthwithoutdecimal() {
      if (
        this.AllowOnlyDecimalTill == 0 ||
        this.AllowOnlyDecimalTill == undefined
      )
        return this.maxlength;
      else return this.maxlength - this.AllowOnlyDecimalTill - 1;
    },
  },

  async created() {},
  methods: {
    changeFormatToNumber(value) {
      this.isFocus = true;
      this.refreshKey++;
      if (!this.isAllowOnlyNumber) {
        return;
      }

      if (
        (value != "" && Number(value) === 0) ||
        value == format(this.currencyFormat)(0)
      )
        return this.$emit("change", "");
    },
    triggerChange(value) {
      this.isFocus = false;
      this.refreshKey++;

      if (value == "" && this.isAllowOnlyNumber) return this.$emit("change", 0); //format(this.currencyFormat)(0));
    },

    subscribeInputChange(newValue, evt) {
      if (this.isAllowOnlyNumber == false) {
        this.$emit("change", newValue);
        return;
      }

      if (newValue == "-" || newValue == "") {
        this.$emit("change", "");
        return "0";
      }
      if (isNaN(newValue)) {
        evt.target.value = "0";
        this.$emit("change", 0);
        return "0";
      }
      if (this.isAllowOnlyInteger) {
        newValue = parseInt(newValue);
      }
      if (newValue.length > this.maxlength && newValue.indexOf(".") > 0) {
        newValue = newValue.substring(0, this.maxlength);
      } else if (
        newValue.length > this.getlengthwithoutdecimal &&
        newValue.indexOf(".") == -1
      ) {
        newValue = newValue.substring(
          0,
          this.maxlength - this.AllowOnlyDecimalTill - 1
        );
      }
      if (newValue > this.maxvalue) {
        newValue = this.maxvalue;
      } else {
        if (newValue < this.minvalue) {
          newValue = this.minvalue;
        }
      }
      event.target.value = newValue;

      this.$emit("change", Number(newValue));
      this.$emit("editableRowButtonClick");
    },
    onKeyUp(event) {
      if (event.target.value.indexOf(".") != -1) {
        let value = event.target.value.toString().split(".");
        if (value[1] != "") {
          if (value[1].length > this.AllowOnlyDecimalTill) {
            value[1] = value[1].substring(0, 2);
            event.target.value = parseFloat(value[0] + "." + value[1]);
            event.preventDefault();
            this.$emit("change", Number(event.target.value));
            return;
          }
        }
        // alert(event.target.value);
        // this.subscribeInputChange(event.target.value, event);
        // event.preventDefault();
        // return;
      }
    },
    numbersOnly(evt) {
      if (this.isAllowOnlyNumber == false) return true;

      if (this.isAllowOnlyNumber > 0) {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode == 13) {
          this.$emit("submit", Number(evt.currentTarget.value));
        }
        if (charCode == 46) {
          if (evt.currentTarget.value == "") {
            evt.preventDefault();
          }
          if (
            evt.currentTarget.value.indexOf(".") < 0 &&
            !this.isAllowOnlyInteger
          ) {
            return true;
          } else {
            evt.preventDefault();
          }
        } else if (
          this.isAllowNegative &&
          charCode == 45 &&
          evt.currentTarget.value.indexOf("-") == -1
        ) {
          return;
        }

        // if (evt.currentTarget.value.indexOf(".") > 0) {
        //   var txtlen = evt.currentTarget.value.length;
        //   var dotpos = evt.currentTarget.value.indexOf(".");
        //   //Change the number here to allow more decimal points than 2
        //   if (txtlen - dotpos > this.AllowOnlyDecimalTill) evt.preventDefault();
        // }

        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
        ) {
          evt.preventDefault();
        } else {
          return true;
        }
      }
      return true;
    },
  },
};
</script>
<style lang="scss" module>
@import "@mds/constants";
@import "@mds/typography";

.adl-input {
  .label {
    @include mds-body-text-m();
    margin-bottom: $mds-space-1-and-a-half-x;
  }

  .charcount {
    @include mds-body-text-s();
  }

  .mds-microcopy {
    margin-top: 8px;
  }
}
</style>
